export default function getIndividuals(user) {
    const individuals = []
    if (user) {
        individuals.push({
            id: user.id,
            name: `${user.firstName} ${user.lastName}`,
            relationship: "Self",
        })
        if (user.dependents) {
            for (const dependent of user.dependents) {
                const fullName = `${dependent.firstName} ${dependent.lastName}`
                const relationship = dependent.relationship
                const id = dependent.id
                individuals.push({
                    id: id,
                    name: fullName,
                    relationship: relationship,
                })
            }
        }
    }
    return individuals;
}